import moment from "moment";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import TaskPreview from "../../../Components/TaskPreview";
import "./preview.css";

const days = [...Array(7).keys()];

export default function Upcoming({ taskClicked }) {
  const courses = useSelector((state) => state.courses);
  const allTasks = useSelector((state) =>
    state.tasks.filter((t) => !t.complete)
  );

  const noDate = (courseId) => {
    const noDates = allTasks.filter(
      (t) => t.courseId === courseId && t.date === "NOTSET"
    );
    const upcoming = allTasks.filter(
      (t) =>
        t.courseId === courseId &&
        t.date !== "NOTSET" &&
        moment(t.date).isSameOrAfter(moment().add(1, "week").startOf("day"))
    );
    return (
      <td style={{ verticalAlign: "top" }}>
        <div
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            width: "100px",
          }}
        >
          {noDates.length > 0 && (
            <div style={{ textAlign: "center" }}>No Date</div>
          )}
          {noDates.map((t) => (
            <TaskPreview task={t} showDate={false} onClick={taskClicked} />
          ))}
          {upcoming.length > 0 && (
            <div style={{ textAlign: "center" }}>Upcoming</div>
          )}
          {upcoming
            .sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf())
            .map((t) => (
              <TaskPreview task={t} onClick={taskClicked} />
            ))}
        </div>
      </td>
    );
  };

  const tableCell = (courseId, days) => {
    const date = moment().add(days, "days");
    const allCourseIds = courses.map((c) => c.id);
    const tasksWithout = allTasks.filter(
      (t) => !allCourseIds.includes(t.courseId)
    );
    let tasks = [];
    if (courseId === null) {
      tasks = tasksWithout.filter((t) => moment(t.date).isSame(date, "day"));
    } else {
      tasks = allTasks.filter(
        (t) => t.courseId === courseId && moment(t.date).isSame(date, "day")
      );
    }
    // return <td>{tasks.length}</td>;
    return (
      <td
        style={{
          height: "30px",
          borderBottom: "solid",

          borderColor: "#AAA",
          borderLeftStyle: "solid",
          borderLeftWidth: 1,
          borderBottomWidth: 0.5,
          margin: 0,
        }}
      >
        {tasks.map((t) => (
          <div
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              width: "100px",
            }}
          >
            <TaskPreview task={t} showDate={false} onClick={taskClicked} />
          </div>
        ))}
      </td>
    );
  };
  const dayLabel = (d) => {
    return <td>{moment().add(d, "days").format("ddd")}</td>;
  };

  return (
    <div>
      <table style={{ width: "100%" }}>
        <tr>
          <td></td>
          {courses.map((c) => {
            return <th>{c.name}</th>;
          })}
          <td>Other</td>
        </tr>

        {days.map((d) => (
          <tr>
            {dayLabel(d)}
            {courses.map((c) => tableCell(c.id, d))}
            {tableCell(null, d)}
          </tr>
        ))}
        <tr>
          <td></td>
          {courses.map((c) => noDate(c.id))}
          {noDate(null)}
        </tr>
      </table>
    </div>
  );
}
